import { connect } from 'react-redux';
import { getIsHotelOnly } from 'src/store/view/selectors';
import { ACTUALIZATION_TIMEOUT } from 'checkout/store/constants/actualization';
import { getInstantConfirm } from 'checkout/store/selectors/package';
import {
  newPriceSelector,
  oldPriceSelector,
} from 'checkout/store/selectors/price';
import {
  getActualizationFetching,
  getIsPriceChangedSignificantly,
  getLastUpdated,
  getPriceChangeDirection,
  getShowPriceChanged,
} from 'checkout/store/selectors/actualization';
import Topbar from './Topbar';
import { HOTEL_CHECKOUT_STEPS, TOUR_CHECKOUT_STEPS } from './constants';
import { getPath } from '../../store/selectors/router';
import { getStepPath } from '../../utils/globalUtils';
import { goToPathAction, setShowSummaryAction } from '../../store/actions/view';
import { getPackageFullPrice } from '../../store/selectors/order';

const mapStateToProps = (state) => {
  const isHotelOnly = getIsHotelOnly(state);
  return {
    currentStep: getStepPath(getPath(state)),
    steps: isHotelOnly ? HOTEL_CHECKOUT_STEPS : TOUR_CHECKOUT_STEPS,
    priceChanged: getShowPriceChanged(state),
    changeDirection: getPriceChangeDirection(state),
    isPriceChangedSignificantly: getIsPriceChangedSignificantly(state),
    oldPrice: oldPriceSelector(state),
    currentPrice: isHotelOnly
      ? getPackageFullPrice(state)
      : newPriceSelector(state),
    lastUpdated: getLastUpdated(state) || 0,
    timeout: ACTUALIZATION_TIMEOUT,
    fetching: getActualizationFetching(state),
    instantConfirm: getInstantConfirm(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClickStep: (path) => dispatch(goToPathAction(path)),
  onOpenSummary: () => dispatch(setShowSummaryAction(true)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Topbar);
